module.exports = __webpack_public_path__ + "img/ambulancia_up_selected.1049cb21.svg";